import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GeneralServiceDocument } from '@mews-distributor/data-access';
import { keyById } from '@mews/fp';

import { ServiceDocuments } from './types';

const dataInitialState: ServiceDocuments['data'] = {};

interface SetServiceDocumentsResponse {
    serviceDocuments: GeneralServiceDocument[];
}

const serviceDocumentsDataSlice = createSlice({
    name: 'serviceDocumentsData',
    initialState: dataInitialState,
    reducers: {
        setServiceDocuments: (
            state,
            { payload: { serviceDocuments } }: PayloadAction<SetServiceDocumentsResponse>
        ) => ({
            ...state,
            ...keyById(serviceDocuments),
        }),
    },
});

const serviceDocumentsSlice = combineReducers({
    data: serviceDocumentsDataSlice.reducer,
});

const { setServiceDocuments } = serviceDocumentsDataSlice.actions;

export { setServiceDocuments, serviceDocumentsSlice };
